/* @flow */
/**
 * Created by Ondra on 10.11.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {closeNewTable, openTable} from '../../common/tables/actions';
import Keyboard from '../components/keyboard/Keyboard';
import {setFocusId, setFirstKey} from '../../common/components/keyboard/actions';
import {setField, resetFields} from '../../common/lib/redux-fields/actions';
import {isEnv} from '../../common/lib/util';

class NewTablePopup extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        closeNewTable: React.PropTypes.func,
        setFirstKey: React.PropTypes.func,
        resetFields: React.PropTypes.func,
        fields: React.PropTypes.object,
        setFocusId: React.PropTypes.func,
        setField: React.PropTypes.func,
        openTable: React.PropTypes.func,
        selectedProducts: React.PropTypes.object,
        tables: React.PropTypes.object,
        newTableUuid: React.PropTypes.string
    };

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.isNameUnique = this.isNameUnique.bind(this);
        this.getValue = this.getValue.bind(this);
        this.focusInput = this.focusInput.bind(this);
    }

    getValue() {
        const {fields} = this.props;
        return !!fields.getIn('tableName') ? fields.getIn('tableName') : '';
    }

    onChange({target: {name, value}}) {
        const {setField} = this.props;
        if (value.length > 33) {
            value = value.substring(0, value.length - 1);
        }
        setField(name, value);
    }

    onSubmit(e) {
        e.preventDefault();

        const {openTable, newTableUuid, resetFields, selectedProducts, msg} = this.props;
        if (this.isNameUnique() && this.getValue().trim().length > 0) {
            openTable(newTableUuid, this.getValue(), selectedProducts.size > 0, msg);
            resetFields('tableName');
        }
    }

    componentWillUnmount() {
        const {resetFields} = this.props;
        resetFields('tableName');
    }

    isNameUnique() {
        const {tables} = this.props;
        return tables.filter(t => t.get('name') === this.getValue().trim()).size === 0
    }

    componentWillMount() {
        const {tables, newTableUuid, setField, setFirstKey} = this.props;
        const tablePosition = tables.getIn([newTableUuid, 'position']);

        setField('tableName', `účet ${tablePosition}`);
        setFirstKey();
        setTimeout(function(){
            const input = document.getElementById('tableName');
            input.select();
        }, 100);
    }

    focusInput(id) {
        const {setFocusId} = this.props;
        setFocusId(id);
    }

    render() {
        const {closeNewTable, msg} = this.props;

        const idNameUnique = this.isNameUnique();
        const disabled = !idNameUnique || this.getValue().trim().length === 0;

        return (
            <div className="pageModal">
              <div className="pageModal-modal">
                <div id="bill-name-popup" className="modal">
                    <div className="modal-box">
                        <h1 className="modal-title">{msg.tables.newPopup.title}</h1>
                        <div className="modal-closer" onClick={() => closeNewTable()}>
                          <svg className={`shape shape-times view-white`}>
                            <use xlinkHref={`#shape-times`}></use>
                          </svg>
                        </div>
                        <div className="modal-content">
                            <div className="input">
                                <form className="formWithKeyboard"
                                      id="formWithKeyboard"
                                      onSubmit={(e) => this.onSubmit(e)}
                                      onChange={e => this.onChange(e)}
                                >

                                    <input autoFocus="autoFocus"
                                           autoCapitalize="off"
                                           autoCorrect="off"
                                           autoComplete="off"
                                           className="keyboardPanel-input"
                                           spellCheck="off"
                                           tabIndex="1"
                                           onFocus={() => this.focusInput('tableName')}
                                           type="text"
                                           id="tableName"
                                           value={this.getValue()}
                                           name="tableName"/>
                                    <div className="keyboardPanel-errors">
                                        <div className="errors">
                                            &nbsp;
                                            {!idNameUnique && this.getValue().trim().length > 0 &&
                                                <span>{msg.tables.newPopup.nameNotUnique}</span>
                                            }
                                        </div>
                                    </div>

                                    <button className={`btn btn-green btn-block ${disabled ? 'disabled' : ''}`}
                                            disabled={disabled}>
                                        {msg.global.save}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div className="pageModal-keyboard">
                {isEnv(['electron', 'web_desktop']) &&
                <Keyboard maxLength={33} />
                }
              </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    selectedProducts: state.categories.get('selectedProducts'),
    fields: state.fields,
    tables: state.categories.get('tables'),
    newTableUuid: state.tables.get('newTableUuid')
}), {closeNewTable, openTable, setFocusId, setField, resetFields, setFirstKey})(NewTablePopup);



// WEBPACK FOOTER //
// ./src/browser/tables/NewTablePopup.js